import { React, useState, useEffect } from 'react';
import { initializeApp } from 'firebase/app';
import { GoogleAuthProvider,FacebookAuthProvider, getAuth, signInWithPopup, signOut } from "firebase/auth";
import { getDatabase, ref, onValue, query, orderByChild, limitToFirst, limitToLast, onChildAdded, endAt } from "firebase/database";

import '../style/header.scss';

import { Link } from "react-router-dom";

import logo from '../images/sqf-puzzles.png';
import loginIcon from "../images/svg/login.svg";
import book from "../images/svg/book.svg";
import close from "../images/svg/close.svg";
import google from "../images/google.png";
import facebook from "../images/facebook.png";
import ichessLogo from "../images/ichess-logo.png";

const Login = () => {
	
	const [data, setData] = useState(null);
	const [error, setError] = useState(null);
	const [popUpBox, setPopUpBox] = useState(false);
	//const [getLoginUserData, setGetLoginUserData] = useState(null);
	var getLoginUserData = null;
	var loginUserEmail = '';
	var loginUserUid = '';

	const [menuActive,setMenuActive] = useState(false);
	
	const [notifyInState, setNotifyInState] = useState(false);
	const [notifyOutState, setNotifyOutState] = useState(false);
	
	const firebaseConfig = {
		apiKey: "AIzaSyAud-tb5lCQSCM-gifT2XCzmDYJIw7Qz3c",
		authDomain: "bubbly-team-559.firebaseapp.com",
		databaseURL: "https://bubbly-team-559.firebaseio.com",
		projectId: "bubbly-team-559",
		storageBucket: "bubbly-team-559.appspot.com",
		messagingSenderId: "344844240563",
		appId: "1:344844240563:web:76ca746813beb8e46f52c6",
		measurementId: "G-7FRS424CRZ"
	};

	const app = initializeApp(firebaseConfig);
	const auth = getAuth(app);
	/* const database = getDatabase(app);*/
	
	const googleProvider = new GoogleAuthProvider();
	const signInWithGoogle = async () => {
		try {
			const res = await signInWithPopup(auth, googleProvider);
			const user = res.user;
			//console.log(user);
			localStorage.setItem('loginUserData', JSON.stringify(user));
			closePopUp();
			setNotifyInState(true);
			setTimeout(function () {
				setNotifyInState(false);
			}, 3000);
		} catch (err) {
			console.error(err);
			//alert(err.message);
		}
	};
	
	
	/* const facebookProvider = new FacebookAuthProvider();
	const signInWithFacebook = async () => {
		try {
			const result = await signInWithPopup(auth, facebookProvider);
			const user = result.user;
			//console.log(user);
			closePopUp();
			// This gives you a Facebook Access Token. You can use it to access the Facebook API.
			const credential = FacebookAuthProvider.credentialFromResult(result);
			const accessToken = credential.accessToken;
		} catch (error) {
			// Handle Errors here.
			const errorCode = error.code;
			const errorMessage = error.message;
			// The email of the user's account used.
			const email = error.customData.email;
			// The AuthCredential type that was used.
			const credential = FacebookAuthProvider.credentialFromError(error);
		}
	}; */
	
	const logOut = () => {
		signOut(auth);
		localStorage.removeItem('loginUserData');
		setNotifyOutState(true);
		setTimeout(function () {
			setNotifyOutState(false);
			window.location.reload(false);
		}, 3000);
		//console.log('logout');
		//console.log(getLoginUserData);
	}
  
	const getUserData = () => {
		getLoginUserData = JSON.parse(localStorage.getItem("loginUserData"));
		//console.log(getLoginUserData);
		if(getLoginUserData != null) {
			loginUserEmail = getLoginUserData.email;
			//console.log(loginUserEmail);
			loginUserUid = getLoginUserData.uid;
			//console.log(loginUserUid);
		}
	}
	getUserData();
	
	useEffect(() => {
		const getData = async () => {
			try {
				const requestOptions = {
					method: 'POST'
				};
				const response = await fetch(
					'https://p1.squareoffnow.com/api/ichess?uid='+loginUserUid+'&email='+loginUserEmail+'&saveUser=1' , requestOptions
				);
				if (!response.ok) {
					throw new Error(
					`This is an HTTP error: The status is ${response.status}`
					);
				}
				let actualData = await response.json();
				//setData(actualData);
				setData(actualData);
				//console.log(actualData);
				setError(null);
			} catch(err) {
				setError(err.message);
				setData(null);
			} 
		}
		if(getLoginUserData != null) {getData()}
	}, []);
  
	/*const eventsRef = query(ref(database, 'events/'), orderByChild('index'), limitToFirst(120));
	
	onValue(eventsRef, (snapshot) => {
		snapshot.forEach((childSnapshot) => {
			const data = childSnapshot.val();
			//console.log(data);
		});
	}); */
  
	
	const openPopUp = () => {
		setPopUpBox(true);
	}
	
	const closePopUp = () => {
		setPopUpBox(false);
	}

	const toggleMenu = event => {
		setMenuActive(current => !current);
	};
  
	return (
		
		<div className="wdh">

			<div className="header">
				<div className="header-box posr">
				<a rel="noreferrer" href="https://squareoffnow.com/"><img src={logo} className="logo" alt="logo" /></a>
					<div className="hide-on-desktop">
						<p className="login-anchor" onClick={() => getLoginUserData ? logOut() : openPopUp() }> 
							<img src={loginIcon} className="login-svg" alt="icon" /> 
							{getLoginUserData ? 'Logout' : 'Login'}
						</p>
					</div>	
					<div className="hide-on-desktop">
						<div className="hamburger-lines" onClick={toggleMenu}>
							<span className={'line line1' + (menuActive ? ' active' : '')}></span>
							<span className={'line line2' + (menuActive ? ' active' : '')}></span>
							<span className={'line line3' + (menuActive ? ' active' : '')}></span>
						</div>  
					</div>  
					<div className={'menu' + (menuActive ? ' active' : '')}>
    					<div className="menu-sub">
							<a className="menu-a" target="_blank" rel="noreferrer" href="https://live.squareoffnow.com/">Live Games</a>
							<a className="menu-a" target="_blank" rel="noreferrer" href="https://squareoffnow.com/apps/gifs">GIFS</a>
							<a className="menu-a" target="_blank" rel="noreferrer" href="https://squareoffnow.com/#productMinistore">Explore Products</a>
    						<a className="menu-a" target="_blank" rel="noreferrer" href="https://squareoffnow.com/contact-us">Contact Us</a>
							<a className="menu-a the-app" target="_blank" rel="noreferrer" href="https://squareoffnow.com/mobile-app">The App</a>
							<div className="hide-on-mobile">
							<p className="login-anchor" onClick={() => getLoginUserData ? logOut() : openPopUp() }> 
								<img src={loginIcon} className="login-svg" alt="icon" /> 
								{getLoginUserData ? 'Logout' : 'Login'}
							</p>
							</div>
    					</div>
    				</div>
				</div>
			</div>

			{/* <div className="title-box">
				<img src={ichessLogo} className="ichess-logo" alt="logo" />
				<p className="login-anchor" onClick={() => getLoginUserData ? logOut() : openPopUp() }> 
					<img src={loginIcon} className="login-svg" alt="icon" /> 
					{getLoginUserData ? 'Logout' : 'Login'}
				</p>
			</div> */}
			
			<div className={'login-overlay popup-overlay' + (popUpBox ? '' : ' hide')}>
				<div className="popup-flex">
					<div className={'login-box popup-box' + (popUpBox ? ' animate' : '')}>
						<img src={close} onClick={() => closePopUp()} className="login-close-button popup-close-button" alt="icon" />
						<h3 className="login-title align-center">Sign in to solve 1000+ <br /> puzzles & save the progress!</h3>
						<img src={book} className="book-svg" alt="icon" />
						<span className="login-span">Continue with</span>
						<div className="login-sub">
							<p className="login-click google-login" onClick={signInWithGoogle}><img src={google} className="login-icon" alt="icon" /> Continue with Google</p>
							{/* <p className="login-click facebook-login" onClick={signInWithFacebook}><img src={facebook} className="login-icon" alt="icon" /> Continue with Facebook</p> */}
							<p className="not-now-click" onClick={() => closePopUp()}>Not now</p>
						</div>
					</div>
				</div>
			</div>
			
			<div className="toast-notify-overlay">
				<span className={'toast-notify' + (notifyInState ? ' show' : '')}>Welcome!</span>
				<span className={'toast-notify' + (notifyOutState ? ' show' : '')}>See you soon!</span>
			</div>
			
		</div>
	);

  
}

export default Login;